import BaseData from './baseData';

export default class SocialShareData extends BaseData {
	get defaults() {
		return {
			...super.defaults,
			type: 'socialShare',
			contentUrl: 'json/socialShareData.json',
		};
	}

	/**
	 * Looks up date for a social media share from a given ID
	 * @param {string} shareId The id of the social share to look up
	 * @returns {Object} Contains all data related to a share
	 */
	getShareData(shareId) {
		// console.log(this.CN, "[getShare]", { shareId });

		const shares = this.shares || this.data;
		const shareData = shares.find(({ id }) => id === shareId);

		return shareData?.toJSON();
	}
}
